import React from "react";
import { fbSignIn, googleSignIn } from "../firebase/handleSignIn";
import MainStore from "../stores/MainStore";

const VerifyPlayer = () => {
  const { setVerifiedId, player } = MainStore();
  return (
    <div
      className="divColumn"
      style={{ width: "100%", justifyContent: "space-around" }}
    >
      <img
        src="/icons/btn_google_sign_in.png"
        className="icon40"
        onClick={() => {
          googleSignIn(player.uid, setVerifiedId);
        }}
      />
      <img
        src="/icons/btn_facebook_login.png"
        className="icon35"
        onClick={() => {
          fbSignIn(player.uid, setVerifiedId);
        }}
      />
    </div>
  );
};

export default VerifyPlayer;
